





























import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { relationRoles, rolesKeys, rolesValues } from '@/modules/AccountContactRelation/helpers/account-contact'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import { AccountContact } from '@/modules/AccountContactRelation/interfaces/account-contact'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class AccountContactRelationDetail extends mixins(AccountDialog) {
  @Prop({ type: Object as () => AccountContact }) readonly relation!: AccountContact

  relationRoles = relationRoles
  rolesKeys = rolesKeys
  rolesValues = rolesValues

  get roles () {
    const { roles } = this.relation
    if (roles.length === 0) {
      return '-'
    }
    let str = ''
    roles.map(role => {
      str += relationRoles[role] + ', '
    })
    return str.slice(0, -2)
  }

  get acctRoute () {
    const { account } = this.relation as AccountContact
    return {
      name: 'AccountDetailDetail',
      params: {
        id: account.id
      }
    }
  }

  get contRoute () {
    const { contact } = this.relation as AccountContact
    return {
      name: 'ContactDetailDetail',
      params: {
        id: contact.id
      }
    }
  }
}
